import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconSaturation } from '../../../base/icons/svg';
import { inklusivaContextMenuStyles } from '../../../inklusiva/ui-constants';
import { SATURATION_SLIDER_MAXIMUM, SATURATION_SLIDER_MINIMUM } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        ...inklusivaContextMenuStyles(theme)
    };
});
const _onClick = (e) => {
    e.stopPropagation();
};
const SaturationSlider = ({ initialValue, label, onChange }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [saturation, setSaturation] = useState(initialValue || 1);
    const _onSaturationSliderChange = useCallback((event) => {
        const newSaturation = event.currentTarget.value;
        onChange(newSaturation);
        setSaturation(Number(newSaturation));
    }, [onChange]);
    return (React.createElement("div", { "aria-label": t('saturationSlider'), className: classes.contextMenuSlider },
        React.createElement("label", { className: classes.contextMenuSliderLabel, htmlFor: 'saturation-slider-input' }, label),
        React.createElement("div", { className: cx('popupmenu__contents', classes.contextMenuSliderInner), onClick: _onClick },
            React.createElement("span", { className: classes.contextMenuSliderIcon },
                React.createElement(Icon, { size: 22, src: IconSaturation })),
            React.createElement("input", { "aria-label": label, id: 'saturation-slider-input', "aria-valuemax": SATURATION_SLIDER_MAXIMUM, "aria-valuemin": SATURATION_SLIDER_MINIMUM, "aria-valuenow": saturation, max: SATURATION_SLIDER_MAXIMUM, min: SATURATION_SLIDER_MINIMUM, onChange: _onSaturationSliderChange, tabIndex: 0, type: 'range', value: saturation }))));
};
export default SaturationSlider;
